import React from "react";

import { LicenseManager } from "ag-grid-enterprise";
import {
  AgGridReact as RealAgGridReact,
  AgGridReactProps,
} from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { GlobalColumnTypes } from "components/AgGrid/globalColumnTypes";

import { EMPTY_OBJECT } from "lib";

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-084370}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{AgriNous}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{AgriNous}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{AgriNous}_need_to_be_licensed___{AgriNous}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_November_2026}____[v3]_[01]_MTc5Mzc1MDQwMDAwMA==58af2fbb3e8d64eb7896b2c50a2386e1",
);

const AgGrid = ({
  defaultColDef,
  columnTypes = EMPTY_OBJECT as NonNullable<AgGridReactProps["columnTypes"]>,
  ...props
}: AgGridReactProps) => {
  const allColumnTypes = React.useMemo(
    () => ({ ...GlobalColumnTypes, ...columnTypes }),
    [columnTypes],
  );

  return (
    <RealAgGridReact
      defaultColDef={defaultColDef}
      columnTypes={allColumnTypes}
      {...props}
    />
  );
};

export default AgGrid;
